import { useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useReportFileDownload } from "../../hooks/useReportFileDownload";
import { INSTALLED_BASE_BASE } from "../../utils/installedBaseUrl";

/**
 * Deep-link target for IoT report notifications with ABSOLUTE redirect URLs
 * ({baseUrl}/installedBase/{nodeId}/files/{fileId}). Novu opens those via
 * window.open in a new tab (routerPush only fires for relative paths), and
 * e-mail links hit this URL directly. Kicks off the report download and
 * immediately replace-redirects to the tree with the node selected; the
 * global snackbar keeps reporting download progress.
 */
const InstalledBaseFileDownload = () => {
    const { nodeId, fileId } = useParams();
    const navigate = useNavigate();
    const { downloadReportFile } = useReportFileDownload();

    // One-shot: guard against StrictMode double-invocation in dev.
    const startedRef = useRef(false);
    useEffect(() => {
        if (startedRef.current || !nodeId || !fileId) return;
        startedRef.current = true;
        void downloadReportFile({ nodeId, fileId });
        navigate(`${INSTALLED_BASE_BASE}/${encodeURIComponent(nodeId)}`, { replace: true });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nodeId, fileId]);

    return null;
};

export default InstalledBaseFileDownload;
